import http from "@/helper/http";
import {BaseVO, GetByIdBO, PaginationBO, PaginationVO} from "@/model/global";
import {useMutation, useQuery} from "@tanstack/react-query";
import {SiteAccountPO} from "@/model/product";
import {WriteSiteAccountForm} from "@/widget/SiteAccount/WriteSiteAccount";

export enum SiteAccountEnum {
    GetSiteAccountPage = "/siteAccount/getSiteAccountPage",
    GetSiteAccount = "/siteAccount/getSiteAccount",
    CreateSiteAccount = "/siteAccount/createSiteAccount",
    UpdateSiteAccount = "/siteAccount/updateSiteAccount",
}

export interface SiteAccountPageVO extends SiteAccountPO {
    siteName: string;
}

export interface SiteAccountPageBO extends PaginationBO {
    customerId?: number
}

export interface SiteAccountVO extends SiteAccountPO {

}

export interface SiteAccountPageVO extends SiteAccountPO {
    avatar: string;
    creator: string;
}

export const useQuerySiteAccountPage = () => useMutation({
    mutationFn: (data: SiteAccountPageBO) => http.post<BaseVO<PaginationVO<SiteAccountPageVO>>>({
        url: SiteAccountEnum.GetSiteAccountPage,
        data: data,
    }),
})

export const useCreateSiteAccount = () => useMutation({
    mutationFn: (data: WriteSiteAccountForm) => http.put<BaseVO<null>>({url: SiteAccountEnum.CreateSiteAccount, data}),
})

export const useUpdateSiteAccount = () => useMutation({
    mutationFn: (data: WriteSiteAccountForm) => http.post<BaseVO<null>>({url: SiteAccountEnum.UpdateSiteAccount, data}),
})

export const useQuerySiteAccount = (params: GetByIdBO, enabled = true) => useQuery<BaseVO<SiteAccountVO>>({
    queryKey: [params.id], queryFn: () => http.get<BaseVO<SiteAccountVO>>({
        url: SiteAccountEnum.GetSiteAccount,
        params: params
    }),
    enabled
})


